module.exports = __webpack_public_path__ + "media/images/athletes/4241-685e6b0916a52397b428e6e3ef5fb1c2.png";